import { Logger, LoggerService } from "@Shared/logger/index";
import {PipelineStep} from "@Modules/pipeline_module/_base";
import {EntitlementService} from "@Modules/entitlement_module";
import {CheckAuthStatusStep} from "@Modules/pipeline_module/steps";
import {ENTITLEMENTS_CONST} from "@Modules/entitlement_module";
import {UrlUtil} from "@Shared/utils";

export class ClearEntitlementCacheStep implements PipelineStep{
    private Logger: Logger = LoggerService.createLogger("ClearEntitlementCacheStep");

    constructor() {
        this.Logger.trace("****  CTOR ****");
    }
    
    async execute(){
        const cacheResult = await EntitlementService.Instance.clearCachedEntitlements();
        if( !cacheResult ) {
            this.Logger.warn("clearEntitlementsCache error, skipping refetch.");
        } else  UrlUtil.removeQueryParam(ENTITLEMENTS_CONST.clearEntitlementsCache);
        return new CheckAuthStatusStep();
    }
}